import { render, staticRenderFns } from "./MarketplacePercentage.vue?vue&type=template&id=2dff1e18&scoped=true"
import script from "./MarketplacePercentage.vue?vue&type=script&lang=js"
export * from "./MarketplacePercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff1e18",
  null
  
)

export default component.exports